import React from 'react';
import GradientOutlineButton from '../../components/atoms/GradientOutlineButton';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gradient-to-r from-[#C572A7] to-[#7F76AF] text-white px-4">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <h2 className="text-2xl md:text-4xl font-semibold mb-2">
        Page Not Found
      </h2>
      <p className="text-lg md:text-xl mb-6 text-center max-w-[500px]">
        Oops! The page you're looking for doesn't exist or has been moved.
      </p>
      <GradientOutlineButton
        width="bg-white"
        text="Go to Home"
        navigateTo={'/'}
      />
    </div>
  );
};

export default NotFoundPage;
